import { Container } from '@/components'
import { Star } from 'lucide-react'
import { testimonials } from '@/data'
import styles from './Testimonials.module.css'

const Testimonials = () => {
  return (
    <section className={styles.testimonials}>
      <Container>
        <div className={styles.testimonialsContent}>
          <h2 className={styles.sectionTitle}>What Our Customers Say</h2>
          <p className={styles.testimonialsLead}>
            Our work speaks for itself, but our customers are also pleased
            with how we conduct business. Hear what they have to say!
          </p>

          <div className={styles.testimonialsGrid}>
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className={styles.testimonialCard}>
                <h4>{testimonial.name}</h4>
                <h6>{testimonial.title}</h6>
                <p>{testimonial.text}</p>
                <div className={styles.stars}>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={`star-${star}`} size={24} color="var(--blue-9)" fill="var(--blue-7)" />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Testimonials 